import { dermatology_sub_steps, step_status } from "./enum";

export function setDermatologyStepStatus({
  result_payload,
  screen_to_complete,
  current_screen_state,
}) {
  const nextScreen = current_screen_state?.nextScreen;
  const sub_steps = {
    ...result_payload?.case?.dermatology_steps?.sub_steps,
    [screen_to_complete]: step_status.completed,
  };

  if (nextScreen && nextScreen !== dermatology_sub_steps.referral_source) {
    sub_steps[nextScreen] = checkAlreadyCompleted({
      screen_name: nextScreen,
      dermatology_steps: result_payload?.case?.dermatology_steps,
      step_placement: "sub_steps",
    });
  }

  delete sub_steps[dermatology_sub_steps.referral_source];

  let resultDuplicated = {
    ...result_payload,
    case: {
      ...result_payload?.case,
      dermatology_steps: {
        main_steps: {
          ...result_payload?.case?.dermatology_steps?.main_steps,
        },
        sub_steps,
      },
    },
  };
  return resultDuplicated;
}

export function checkAlreadyCompleted({
  screen_name,
  dermatology_steps,
  step_placement,
}) {
  if (
    dermatology_steps?.[step_placement]?.[screen_name] &&
    dermatology_steps?.[step_placement]?.[screen_name] === step_status.completed
  ) {
    return step_status.completed;
  } else {
    return step_status.current;
  }
}

export function setNextScreenToUpcoming({ state, status, nextScreen }) {
  if (
    status === step_status.completed &&
    state.subSteps[nextScreen].status === step_status.upcoming
  ) {
    state.subSteps[nextScreen].status = step_status.current;
  } else {
    return;
  }
}
